export const getInitialState = () => ({
    fetchStatus: "initial",
    flights: [],
    availableFilters: {},
    subsidizedFaresSummary: [],
    error: undefined,
    campaignBanner: undefined,
    searchCriteria: undefined,
    searchId: undefined,
    displayOptions: undefined,
    sortingOptions: undefined,
    pagination: {
        count: 0,
        currentPage: 1,
        pagesCount: 1,
        pageSize: 1
    },
    banners: undefined
});
